import React from "react";
import { Box, Typography, Button } from "@mui/material";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import ModalComponent from "./Modal";

const WarningModal = ({ open, onClose, onConfirm, title, description, buttonText = "Entendido" }) => {
  return (
    <ModalComponent open={open} handleClose={onClose} width="500px">
      <Box
        sx={{
          textAlign: "center",
          p: 4,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            color: "error.main",
            width: 60,
            height: 60,
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            mb: 3,
          }}
        >
          <WarningAmberRoundedIcon color="error" sx={{ fontSize: 50, mb: 2 }} />
        </Box>
        <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
          {title}
        </Typography>
        <Typography variant="body1" sx={{ color: "text.secondary", mb: 3, maxWidth: "400px" }}>
          {description}
        </Typography>
        <Button
          onClick={onConfirm}
          variant="contained"
          color="primary"
          size="medium"
          sx={{
            px: 4,
            py: 1,
            borderRadius: "8px",
            textTransform: "none",
            fontWeight: 500,
            fontSize: "1rem",
            boxShadow: "none",
            "&:hover": {
              backgroundColor: "primary.dark",
            },
          }}
        >
          {buttonText}
        </Button>
      </Box>
    </ModalComponent>
  );
};

export default WarningModal;
